'use client'
import React, { useEffect, useRef, useState } from 'react'
import { useLazyQuery } from '@apollo/client'

import CustomLink from '../customLink'
import MyImage from '../myImage'
import { convertDt24h, dateCheck, getImgURL, isBottomReached } from '@/shared/utils'
import { BLUR_DATA_URL_BASE64 } from '@/shared/constants'
import articlePlaceholder from '@/assets/images/placeholder/articlePlaceholder.svg'
import { GET_SERIES_NEWS } from '@/graphql/series/news.query'
import tableVector from '@/assets/images/error-images/news.svg'
import IconTimer from '@/assets/images/icon/timer.svg'
import IconDate from '@/assets/images/icon/date.svg'
import Loading from '../loading'
import NoData from '../noData'
import { GET_TAG_ARTICLE } from '@/graphql/tag/tag.query'
import Button from '../button'

function NewsTab({ data, id, type }: any) {
  const [isLoadMore, setIsLoadMore] = useState(false)
  const [skip, setSkip] = useState(1)
  const [newsData, setNewsData] = useState(data?.aResults || [])
  const loading = useRef(false)

  const [getSeriesNews, { loading: seriesLoading }] = useLazyQuery(GET_SERIES_NEWS, {
    onCompleted: (d) => {
      const t = d?.listSeriesArticlesVideosFront?.oArticles?.aResults
      if (t?.length > 0) {
        setNewsData([...newsData, ...t])
      }
    }
  })

  const [getPlayerNews, { loading: playerLoading }] = useLazyQuery(GET_TAG_ARTICLE, {
    onCompleted: (d) => {
      const t = d?.getTagArticlesFront?.aResults
      if (t?.length > 0) {
        setNewsData([...newsData, ...t])
      }
    }
  })

  useEffect(() => {
    loading.current = false
    if (newsData?.length && isLoadMore) isBottomReached(newsData[newsData.length - 1]?._id, isReached)
  }, [newsData])

  async function isReached(reach: any) {
    if (reach) {
      loading.current = true
      setSkip((t) => t + 1)
      if (type === 'series') {
        getSeriesNews({ variables: { input: { iSeriesId: id, nSkip: skip + 1, nLimit: 10, eType: 'n' } } })
      } else if (type === 'player' || type === 'team') {
        const t = type === 'player' ? 'p' : 't'
        getPlayerNews({ variables: { input: { _id: id, eType: t, nLimit: 10, nSkip: skip + 1 } } })
      }
    }
  }

  function handleLoadMore() {
    setIsLoadMore(true)
    if (type === 'series') {
      getSeriesNews({ variables: { input: { iSeriesId: id, nSkip: skip + 1, nLimit: 10, eType: 'n' } } })
    } else if (type === 'player' || type === 'team') {
      const t = type === 'player' ? 'p' : 't'
      getPlayerNews({ variables: { input: { _id: id, eType: t, nLimit: 10, nSkip: skip + 1 } } })
    }
    setSkip((p) => p + 1)
  }

  return (
    <>
      <div className='grid grid-cols-12 gap-4 mt-4'>
        {newsData?.map((d: any, i: number) => {
          if (i < 4) {
            return (
              <CustomLink
                href={`/${d?.oSeo?.sSlug}`}
                className='col-span-12 sm:col-span-6 lg:col-span-6 flex gap-3 md:gap-0 relative cursor-pointer w-full'
                id={d?._id}
                key={d._id}
              >
                <div className=' w-[110px] md:w-[140px] overflow-hidden flex-shrink-0'>
                  <MyImage
                    src={d?.oImg?.sUrl ? getImgURL(d?.oImg?.sUrl) : articlePlaceholder}
                    alt={d?.oImg?.sText || d?.sSrtTitle}
                    height={200}
                    blurDataURL={BLUR_DATA_URL_BASE64}
                    width={440}
                    className='  rounded-lg sm:rounded-xl object-cover aspect-[16/10]'
                  />
                </div>
                <div className='w-full flex flex-col justify-between md:ml-3'>
                  <div>
                    <div className='text-sm md:text-base text-textOffWhite font-bold line-clamp-2'>{d?.sTitle}</div>
                  </div>
                  <div className='flex items-center text-sm md:text-base text-t-info'>
                    <span className='text-xs md:text-sm flex gap-1 items-center text-textDselected'><MyImage src={IconDate} width={16} height={16} alt='Date' /> {convertDt24h(dateCheck(d?.dPublishDisplayDate || d?.dPublishDate))}</span>
                    <span className='h-1.5 w-1.5 rounded-full bg-textDselected mx-3'></span>
                    <span className='text-xs md:text-sm flex gap-1 items-center text-textDselected'> <MyImage src={IconTimer}  width={16} height={16} alt='timer' /> {d?.nDuration} Min</span>
                  </div>
                </div>
              </CustomLink>
            )
          } else {
            return (
              <CustomLink
                key={d?._id}
                href={`/${d?.oSeo?.sSlug}`}
                className='col-span-12 flex flex-col sm:flex-row gap-3 md:gap-0 relative cursor-pointer w-full pt-7 pb-4 border-t border-tabBorder'
                id={d?._id}
              >
                <div className=' sm:w-1/3 rounded-lg overflow-hidden'>
                  <MyImage
                    src={d?.oImg?.sUrl ? getImgURL(d?.oImg?.sUrl) : articlePlaceholder}
                    alt={d?.oImg?.sText || d?.sSrtTitle}
                    height={200}
                    blurDataURL={BLUR_DATA_URL_BASE64}
                    width={440}
                    className='h-auto aspect-[16/10] rounded-xl object-cover'
                  />
                </div>
                <div className='sm:w-[70%] flex flex-col justify-between md:ml-3'>
                  <div>
                    <div className='text-sm md:text-xl text-textOffWhite font-bold line-clamp-2 mb-3'>{d?.sTitle}</div>
                    <p className='text-xs md:text-base text-textDselected'>{d?.sDescription}</p>
                  </div>
                  <div className='flex items-center text-sm md:text-base text-t-info mt-2'>
                    <span className='text-xs md:text-sm flex gap-1 items-center text-textDselected'><MyImage src={IconDate} width={16} height={16} alt='Date' /> {convertDt24h(dateCheck(d?.dPublishDisplayDate || d?.dPublishDate))}</span>
                    <span className='h-1.5 w-1.5 rounded-full  bg-textDselected mx-3'></span>
                    <span className='text-xs md:text-sm flex gap-1 items-center text-textDselected'> <MyImage src={IconTimer}  width={16} height={16} alt='timer' />{d?.nDuration} Min</span>
                  </div>
                </div>
              </CustomLink>
            )
          }
        })}
      </div>
      {data?.aResults?.length === 10 && !isLoadMore && (
        <div className='flex justify-center items-center mt-6 md:mt-12'>
          <Button className='' onClick={handleLoadMore}>
            <span className='text-base font-semibold'>Load more</span>
          </Button>
        </div>
      )}
      {data?.aResults?.length === 0 && <NoData imagePath={tableVector} />}
      {(seriesLoading || playerLoading) && <Loading />}
    </>
  )
}

export default NewsTab
